module.exports = __webpack_public_path__ + "img/md-git-network.7e6b6071.svg";